import { FlatTaxRateStrategy, LocalizedCurrencySimpleValue } from '@mews-distributor/common';

interface FlatTaxRateProps {
    strategy: FlatTaxRateStrategy;
}

export const FlatTaxRate: React.FC<FlatTaxRateProps> = ({ strategy }) => (
    <LocalizedCurrencySimpleValue value={strategy} />
);
